<template>
  <v-container class="auth-callback fill-height d-flex flex-column align-center justify-center">
    <template v-if="!hasError">
      <v-progress-circular indeterminate color="primary" size="56" width="4" class="mb-4" />
      <h3 class="text-h6 font-weight-medium mb-1">{{ statusMessage }}</h3>
      <p class="text-body-2 text-medium-emphasis">{{ subMessage }}</p>
    </template>
    <template v-else>
      <v-icon icon="mdi-alert-circle-outline" color="error" size="56" class="mb-4" />
      <h3 class="text-h6 font-weight-medium mb-1 text-error">{{ statusMessage }}</h3>
      <p class="text-body-2 text-medium-emphasis mb-6">{{ subMessage }}</p>
      <v-btn color="primary" variant="flat" @click="returnToLogin">
        {{ $t('labels.returnToSignIn') || 'Return to Sign In' }}
      </v-btn>
    </template>
  </v-container>
</template>

<script lang="ts" setup>
import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { processAuthCallback } from '@/router/authGuards'

const route = useRoute()
const router = useRouter()

const statusMessage = ref('Signing you in...')
const subMessage = ref('Setting up your workspace, please wait.')
const hasError = ref(false)

const returnToLogin = () => {
  router.replace({ name: 'Login' })
}

onMounted(async () => {
  try {
    const destination = await processAuthCallback(route)
    if (destination) {
      router.replace(destination)
    }
  } catch (err: any) {
    console.error('Authentication callback failed:', err)
    hasError.value = true
    statusMessage.value = 'Sign In Failed'
    subMessage.value = err?.message || 'Unable to complete sign in. Please try again.'
  }
})
</script>

<style scoped>
.auth-callback {
  min-height: 80vh;
}
</style>
